export enum SECTION_HEADER {
    specifications = 'specifications',
    nodes = 'nodes',
    nodeType = 'nodeType',
    dictionary = 'dictionary',
    products = 'products',
    configurations = 'configurations'
};
